import React from "react";
import { Link } from "react-router-dom";

const LEARNING_PATH = [
  {
    module: "Module 1",
    title: "AI Fundamentals for Operators",
    points: [
      "How LLM workflows actually work",
      "When to use RAG vs static knowledge",
      "Where guardrails matter most",
    ],
  },
  {
    module: "Module 2",
    title: "Adoption & Change Management",
    points: [
      "Designing pilot cohorts",
      "Measuring behavior change",
      "Building confidence with stakeholders",
    ],
  },
  {
    module: "Module 3",
    title: "Production Readiness",
    points: [
      "Prompt and output quality controls",
      "Observability and cost tracking",
      "Release playbooks for scale",
    ],
  },
];

const QUICK_LESSONS = [
  "How to scope your first AI pilot in 30 minutes",
  "5 mistakes teams make with internal copilots",
  "How to write evaluation prompts that reduce hallucinations",
  "A practical policy for human review in AI workflows",
  "What to monitor weekly in production AI systems",
];

export default function LearningCenter() {
  return (
    <main className="min-h-screen bg-white">
      <section className="bg-gradient-to-br from-slate-900 via-cyan-900 to-blue-900 text-white px-4 py-20">
        <div className="max-w-6xl mx-auto">
          <p className="text-xs uppercase tracking-[0.24em] text-cyan-300 font-bold">Learning Center</p>
          <h1 className="text-4xl sm:text-5xl font-black mt-3 max-w-4xl">A structured curriculum for teams adopting AI and modern delivery practices.</h1>
          <p className="text-lg text-slate-300 max-w-3xl mt-5">
            Build shared language and practical capability across product, engineering, marketing, and operations.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-black text-slate-900 mb-8">Core Learning Path</h2>
        <div className="space-y-5">
          {LEARNING_PATH.map((l) => (
            <article key={l.title} className="border border-gray-200 rounded-2xl p-6">
              <p className="text-xs uppercase tracking-wider font-bold text-cyan-700 mb-2">{l.module}</p>
              <h3 className="text-xl font-black text-slate-900 mb-3">{l.title}</h3>
              <ul className="space-y-1.5">
                {l.points.map((p) => (
                  <li key={p} className="text-sm text-slate-600 flex items-start gap-2">
                    <span className="text-cyan-600 font-bold">•</span>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="bg-slate-50 border-y border-gray-100">
        <div className="max-w-6xl mx-auto px-4 py-16">
          <h2 className="text-3xl font-black text-slate-900 mb-6">Quick Lessons</h2>
          <div className="grid md:grid-cols-2 gap-4">
            {QUICK_LESSONS.map((lesson) => (
              <div key={lesson} className="bg-white border border-gray-200 rounded-xl px-4 py-3 text-sm font-medium text-slate-700">
                {lesson}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-16">
        <div className="rounded-2xl bg-gradient-to-r from-cyan-600 to-blue-700 text-white p-8 sm:p-10">
          <h2 className="text-3xl font-black mb-3">Build an internal enablement track</h2>
          <p className="text-cyan-100 mb-6 max-w-2xl">
            Turn this learning path into a company enablement program with custom modules and live workshops.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/consulting" className="px-5 py-2.5 rounded-lg bg-white text-cyan-700 font-bold hover:bg-cyan-50 transition">Request Workshop</Link>
            <Link to="/templates" className="px-5 py-2.5 rounded-lg border border-white/40 text-white font-semibold hover:bg-white/10 transition">Use Templates</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
